'use strict';

exports.__esModule = true;
exports.ReviewAverageRating = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reviewAverageRating = require('../../src/styles/review-average-rating.scss');

var _reviewAverageRating2 = _interopRequireDefault(_reviewAverageRating);

var _starRating = require('../../src/styles/star-rating.scss');

var _starRating2 = _interopRequireDefault(_starRating);

var _tooltip = require('../../../tooltip');

var _starRating3 = require('star-rating');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewAverageRating = exports.ReviewAverageRating = function ReviewAverageRating(props) {
  var overallRating = props.overallRating,
      explanationRating = props.explanationRating,
      bedsideMannerRating = props.bedsideMannerRating;


  return _react2.default.createElement(
    'div',
    { className: '' + _reviewAverageRating2.default['review-average-rating'] },
    _react2.default.createElement(
      'p',
      { className: '' + _reviewAverageRating2.default['review-average-rating__row'] },
      _react2.default.createElement(
        'span',
        { className: '' + _reviewAverageRating2.default['review-average-rating__title'] },
        'Overall'
      ),
      _react2.default.createElement(
        _tooltip.Tooltip,
        null,
        'Would you recommend the professional who treated you?',
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        '1 star = Never',
        _react2.default.createElement('br', null),
        '2 stars = Unlikely',
        _react2.default.createElement('br', null),
        '3 stars = Maybe',
        _react2.default.createElement('br', null),
        '4 stars = Probably',
        _react2.default.createElement('br', null),
        '5 stars = Highly Recommended',
        _react2.default.createElement('br', null)
      ),
      _react2.default.createElement(
        'div',
        { className: _reviewAverageRating2.default['review-average-rating__star-rating'] + ' ' + _starRating2.default['star-rating'] },
        _react2.default.createElement(
          'div',
          { className: '' + _starRating2.default['star-rating__stars'] },
          _react2.default.createElement(_starRating3.StarRating, {
            averageRating: overallRating,
            className: '' + _starRating2.default['star-styles']
          })
        ),
        _react2.default.createElement(
          'span',
          { className: '' + _starRating2.default['star-rating__number-value'] },
          overallRating
        )
      )
    ),
    _react2.default.createElement(
      'p',
      { className: '' + _reviewAverageRating2.default['review-average-rating__row'] },
      _react2.default.createElement(
        'span',
        { className: '' + _reviewAverageRating2.default['review-average-rating__title'] },
        'Explanation'
      ),
      _react2.default.createElement(
        _tooltip.Tooltip,
        null,
        'How well did your specialist explain your condition to you and provide you relevant information?',
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        '1 star = Poorly',
        _react2.default.createElement('br', null),
        '2 stars = Not very well',
        _react2.default.createElement('br', null),
        '3 stars = Adequate',
        _react2.default.createElement('br', null),
        '4 stars = Well',
        _react2.default.createElement('br', null),
        '5 stars = Very well!',
        _react2.default.createElement('br', null)
      ),
      _react2.default.createElement(
        'div',
        { className: _reviewAverageRating2.default['review-average-rating__star-rating'] + ' ' + _starRating2.default['star-rating'] },
        _react2.default.createElement(
          'div',
          { className: '' + _starRating2.default['star-rating__stars'] },
          _react2.default.createElement(_starRating3.StarRating, {
            averageRating: explanationRating,
            className: '' + _starRating2.default['star-styles']
          })
        ),
        _react2.default.createElement(
          'span',
          { className: '' + _starRating2.default['star-rating__number-value'] },
          explanationRating
        )
      )
    ),
    _react2.default.createElement(
      'p',
      { className: '' + _reviewAverageRating2.default['review-average-rating__row'] },
      _react2.default.createElement(
        'span',
        { className: '' + _reviewAverageRating2.default['review-average-rating__title'] },
        'Bedside Manner'
      ),
      _react2.default.createElement(
        _tooltip.Tooltip,
        null,
        'How would you rate this professional\u2019s bedside manner?',
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        '1 star = Poor',
        _react2.default.createElement('br', null),
        '2 stars = Unsatisfactory',
        _react2.default.createElement('br', null),
        '3 stars = Satisfactory',
        _react2.default.createElement('br', null),
        '4 stars = Good',
        _react2.default.createElement('br', null),
        '5 stars = Excellent',
        _react2.default.createElement('br', null)
      ),
      _react2.default.createElement(
        'div',
        { className: _reviewAverageRating2.default['review-average-rating__star-rating'] + ' ' + _starRating2.default['star-rating'] },
        _react2.default.createElement(
          'div',
          { className: '' + _starRating2.default['star-rating__stars'] },
          _react2.default.createElement(_starRating3.StarRating, {
            averageRating: bedsideMannerRating,
            className: '' + _starRating2.default['star-styles']
          })
        ),
        _react2.default.createElement(
          'span',
          { className: '' + _starRating2.default['star-rating__number-value'] },
          bedsideMannerRating
        )
      )
    )
  );
};

ReviewAverageRating.displayName = 'ReviewAverageRating';
ReviewAverageRating.defaultProps = {
  overallRating: 0,
  explanationRating: 0,
  bedsideMannerRating: 0
};
ReviewAverageRating.propTypes = {
  overallRating: _propTypes2.default.number,
  explanationRating: _propTypes2.default.number,
  bedsideMannerRating: _propTypes2.default.number
};

exports.default = ReviewAverageRating;


// WEBPACK FOOTER //
// ./components/profile-right-section/lib/components/review-average-rating.js